

































import { Models } from "@/core/Export";
import store from "@/store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {}
})
export default class EmployeeStandByEditDayLine extends Vue {
  @Prop() props: Array<any>;
  @Prop() canEditMonth: boolean;
  durationText: string;

  constructor() {
    super();
    this.durationText = "";
  }

  created() {
    this.setDurationText();
  }

  onEntryTimeChanged(e) {
    this.props["row"].startTimeText = Models.AppUtils.formatTime(e.target.value);
    this.setDurationText();
  }

  onExitTimeChanged(e) {
    this.props["row"].endTimeText = Models.AppUtils.formatTime(e.target.value);
    this.setDurationText();
  }

  @Watch("props.row")
  setDurationText() {
    this.durationText = "";

    let startTimeText = this.props["row"].startTimeText as any;
    let endTimeText = this.props["row"].endTimeText as any;

    if (!startTimeText || !endTimeText) return;

    this.durationText = Models.AppUtils.calculateDuration(startTimeText, endTimeText);
    if (this.durationText == "00:00") this.durationText = "";
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
